import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { memo, useState } from 'react';
import { XLarge } from '@outdoor-voices/ui';
import Button from '@outdoor-voices/ui/dist/components/Button';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { withListItemDeleteMutation } from './queries';
import css from './ConfirmDelete.module.scss';
import Image from '../../../components/Image';
import OVIDClient from '../../customers/OVIDClient';
import WishListCache from '../../customers/WishListCache';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Details = function Details(_ref) {
  var _assets$edges$;

  var colorway = _ref.colorway,
      id = _ref.id,
      on = _ref.on,
      onDeleted = _ref.onDeleted;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      deleting = _useState2[0],
      setDeleting = _useState2[1];

  var assets = colorway.assets,
      product = colorway.product;
  var asset = ((_assets$edges$ = assets.edges[0]) === null || _assets$edges$ === void 0 ? void 0 : _assets$edges$.node) || false;

  var onDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var client, response, cache;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setDeleting(true);
              client = new OVIDClient();
              _context.next = 4;
              return client.mutate(withListItemDeleteMutation, {
                id: id
              });

            case 4:
              response = _context.sent;
              cache = new WishListCache();
              cache.update(response.data.wishListItemDelete);
              setDeleting(false);
              onDeleted();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.header,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.title,
        children: "Remove item from your wish list"
      }), /*#__PURE__*/_jsx("div", {
        className: css.subTitle,
        children: "Are you sure you don\u2019t want to keep this item?"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.item,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.imageWrap,
        children: /*#__PURE__*/_jsx("div", {
          className: css.image,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, asset.image), {}, {
            sizes: [112]
          }))
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: css.details,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.itemTitle,
          children: product.title
        }), /*#__PURE__*/_jsx("div", {
          className: css.itemColor,
          children: colorway.color
        }), /*#__PURE__*/_jsx("div", {
          className: css.removeButton,
          children: /*#__PURE__*/_jsx(Button, {
            ariaLabel: "Click to confirm removing ".concat(product.title, " in ").concat(colorway.color, " from this wish list"),
            gray: true,
            disabled: deleting,
            onClick: onDelete,
            tabIndex: on ? 0 : -1,
            children: deleting ? 'Removing' : 'Remove'
          })
        })]
      })]
    })]
  });
};

Details.propTypes = {
  colorway: PropTypes.shape({
    color: PropTypes.string,
    assets: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.shape({
          image: PropTypes.shape({})
        })
      }))
    }),
    product: PropTypes.shape({
      title: PropTypes.string
    })
  }).isRequired,
  id: PropTypes.string.isRequired,
  on: PropTypes.bool.isRequired,
  onDeleted: PropTypes.func.isRequired
};

var ConfirmDelete = function ConfirmDelete(_ref3) {
  var colorway = _ref3.colorway,
      id = _ref3.id,
      on = _ref3.on,
      onCancel = _ref3.onCancel,
      onDeleted = _ref3.onDeleted;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.on, on)]),
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": "Click to cancel removing item from your wish list",
      className: css.cancel,
      onClick: onCancel,
      tabIndex: on ? 0 : -1,
      type: "button",
      children: /*#__PURE__*/_jsx(XLarge, {})
    }), id && /*#__PURE__*/_jsx(Details, {
      colorway: colorway,
      id: id,
      on: on,
      onDeleted: onDeleted
    })]
  });
};

ConfirmDelete.propTypes = {
  colorway: PropTypes.shape({}),
  id: PropTypes.string,
  on: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDeleted: PropTypes.func
};
export default /*#__PURE__*/memo(ConfirmDelete);